import { gql } from '@apollo/client';

import { AppFragment } from './App';

export const ProductVariantFragment = gql`
  fragment ProductVariantFragment on ProductVariant {
    name
    mmId
    variablesByApp {
      app {
        ...AppFragment
      }
      price
      availability
      surcharge {
        amount
        type
      }
    }
    posId
  }
  ${AppFragment}
`;

export const MenuVariantFragment = gql`
  fragment MenuVariantFragment on MenuVariant {
    mmId
    posId
    name
    customPosId
    variablesByApp {
      app {
        ...AppFragment
      }
      price
      availability
      surcharge {
        amount
        type
      }
    }
  }
  ${AppFragment}
`;

export const SetVariantAvailabilityMutation = gql`
  mutation SetVariantAvailability($posId: String!, $locationId: String!, $appIds: [String!]!, $isAvailable: Boolean!) {
    setVariantAvailability(posId: $posId, locationId: $locationId, appIds: $appIds, isAvailable: $isAvailable) {
      ...MenuVariantFragment
    }
  }

  ${MenuVariantFragment}
`;
